<template>
  <div class="x-tablelist-view" data-automation="group">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @change="change"
      @search="search"
      @add="showAdd"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>

<script>
import addLicense from './template/addLicense';
import approval from './template/approval';
import modify from './template/modify';
import renewal from './template/renewal';
export default {
  components: {
    addLicense,
    approval,
    modify,
    renewal
  },
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'title',
          hideBtn: true,
          placeholder: this.$t('HT.licenseList.title')
        },
        {
          type: 'input',
          key: 'sales',
          hideBtn: true,
          placeholder: this.$t('HT.addLicense.sales.placeholder')
        },
        {
          type: 'input',
          key: 'engineer',
          hideBtn: true,
          placeholder: this.$t('HT.addLicense.engineer.placeholder')
        },
        {
          type: 'select',
          options: this.$opt.approvalStatus,
          key: 'status',
          placeholder: this.$t('HT.orderManage.status'),
          event: 'change'
        },
        {
          type: 'button',
          text: this.$t('HT.search1'),
          show: true,
          event: 'search'
        },
        {
          type: 'button',
          text: this.$t('HT.licenseList.add'),
          right: true,
          hidden: !this.$hasModule(32),
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.addLicense.userName'),
          tooltip: true,
          render: (h, params) => {
            return h(
              'span',
              {
                class: [params.status == 1 ? 'x-table-blue-btn' : 'no-click'],
                on: {
                  click: () => {
                    if (params.status == 1) {
                      this.$router.push({ name: 'licenseInfo', query: { title: params.title } });
                    } else {
                      return;
                    }
                  }
                }
              },
              params.title
            );
          }
        },
        {
          label: this.$t('HT.addLicense.sales'),
          prop: 'sales',
          tooltip: true
        },
        {
          label: this.$t('HT.addLicense.engineer'),
          prop: 'engineer',
          tooltip: true
        },
        {
          label: this.$t('HT.orderManage.status'),
          prop: 'status',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            let status = '';
            if (row.expire_date - Date.parse(new Date()) / 1000 < 0) {
              status = this.$t('HT.expired');
            } else {
              if (row.status == 2) {
                status =
                  this.$opt.switchStr(cellValue, this.$opt.approvalStatus) +
                  ' (' +
                  row.message +
                  ')'; // 审批被驳回时，显示驳回原因
              } else {
                status = this.$opt.switchStr(cellValue, this.$opt.approvalStatus);
              }
            }
            return status;
          }
        },
        {
          label: this.$t('HT.addLicense.expireDate'),
          prop: 'expire_date',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return this.time.format('YYYY-MM-DD', cellValue * 1000);
          }
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(32),
          width: 200,
          render: (h, params) => {
            let admin = [
              this.$t('HT.approval.status'),
              this.$t('HT.edit2'),
              this.$t('HT.licenseInfo.renewal'),
              this.$t('HT.delete')
            ];
            let user = [this.$t('HT.edit2'), this.$t('HT.recall')];
            let userData = this.$store.state.login.userData;
            return h('my-table-btn', {
              props: {
                data: userData.supervisor ? admin : user, // 判断是超管还是用户
                className: userData.supervisor
                  ? [
                    params.status == 1 ? 'no-click' : '',
                    '',
                    params.status !== 1 ? 'no-click' : '',
                    params.status == 1 ? 'no-click' : ''
                  ]
                  : [params.status == 1 ? 'no-click' : '', params.status == 1 ? 'no-click' : ''],
                colors: ['#0087ff'],
                event: userData.supervisor
                  ? ['approval', 'modify', 'renewal', 'del']
                  : ['modify', 'del']
              },
              on: {
                submit: () => {
                  this.showSubmit(params);
                },
                approval: () => {
                  this.showApproval(params);
                },
                modify: () => {
                  this.showModify(params);
                },
                renewal: () => {
                  this.renewal(params);
                },
                del: () => {
                  const title = this.$t('HT.licenseList.del');
                  const content = this.$t('HT.licenseList.del.content');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.delLicense(params);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        title: null, // 公司名称
        status: null, // 审批状态
        sales: null, // 销售员姓名
        engineer: null, // 技术支持人员姓名
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      userMessage: this.$store.state.login.userData // localStorage用户信息
    };
  },
  created() {
    this.getList(this.filter);
  },

  computed: {
    time() {
      return this.$uxSdk.time;
    }
  },

  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.license.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 新增-弹窗
     */
    showAdd() {
      const title = this.$t('HT.licenseList.add');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addLicense, {
            on: {}
          });
        },
        confirm: (data) => {
          this.addLicense(data);
        }
      });
    },

    /**
     * 新增授权申请
     * @param {Object} params 参数
     */
    addLicense(params) {
      let val = JSON.parse(JSON.stringify(params));
      this.$uxLoading.show();
      let list = {};
      list.phone = val.phone;
      val.extension = JSON.stringify(list);
      var now = Date.parse(new Date()) / 1000; // 获取当前时间戳，转为unix时间
      if (val.expire_date === 0) {
        if (new Date(Date.parse(val.date)).getTime() - Date.parse(new Date()) < 0) {
          // 判断有效期时间是否小于当前时间
          this.$uxMessage.warning(this.$t('HT.licenseList.addLicense.warning'));
          this.$uxLoading.hide();
          return;
        } else {
          val.expire_date = new Date(Date.parse(val.date.replace(/-/g, '/'))).getTime() / 1000; // 将YYYY-MM-DD 转换为 unix单位
        }
      } else {
        val.expire_date = now + val.expire_date * 31536000; // 当前时间加上有效期年份时间
      }
      this.$api.license.addLicense(val).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 审批-弹窗
     * @param {Object} params 参数
     * @data  弹窗返回参数
     */
    showApproval(params) {
      let val = {};
      val.max_conn = params.max_conn;
      val.max_hosts = params.max_hosts;
      val.extension = params.extension;
      const title = this.$t('HT.approval.status');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(approval, {
            props: { data: val },
            on: {}
          });
        },
        confirm: (data) => {
          data.extension = JSON.parse(data.extension);
          data.extension.remark = data.remark;
          data.extension = JSON.stringify(data.extension);
          this.$uxLoading.hide();
          this.$api.license.modify(params.id, data).then((res) => {
            if (res.code == 10000) {
              this.$api.license.approval(params.id, data).then((res) => {
                if (res.code == 10000) {
                  this.$uxModal.hide();
                  this.$uxMessage.success(this.$t('HT.addApi.approvalSuccess'));
                  this.getList(this.filter);
                }
              });
            }
          });
        }
      });
    },

    /**
     * 修改-弹窗
     * @param {Object} params 参数
     */
    showModify(params) {
      const title = this.$t('HT.edit2');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(modify, {
            props: { data: params, user: this.userMessage },
            on: {}
          });
        },
        confirm: (data) => {
          let val = JSON.parse(JSON.stringify(data));
          let list = JSON.parse(data.extension);
          list.phone = val.phone;
          val.extension = JSON.stringify(list);
          var now = Date.parse(new Date()) / 1000; // 获取当前时间戳，转为unix时间
          if (val.expire_date === 0) {
            if (new Date(Date.parse(val.date)).getTime() - Date.parse(new Date()) < 0) {
              // 判断有效期时间是否小于当前时间
              this.$uxMessage.warning(this.$t('HT.licenseList.addLicense.warning'));
              this.$uxLoading.hide();
              return;
            } else {
              val.expire_date = new Date(Date.parse(val.date.replace(/-/g, '/'))).getTime() / 1000; // 将YYYY-MM-DD 转换为 unix单位
            }
          } else {
            val.expire_date = now + val.expire_date * 31536000; // 当前时间加上有效期年份时间
          }
          this.$api.license.modify(params.id, val).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
              this.getList(this.filter);
            }
          });
        }
      });
    },

    /**
     * 续期
     * @param {Object} params 参数
     */
    renewal(params) {
      const title = this.$t('HT.licenseInfo.renewal');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(renewal, {
            props: { data: params },
            on: {}
          });
        },
        confirm: (data) => {
          var now = Date.parse(new Date()) / 1000;
          if (now - params.expire_date > 0) {
            if (data.add_date === 0) {
              data.expire_date =
                new Date(Date.parse(data.date.replace(/-/g, '/'))).getTime() / 1000; // 将YYYY-MM-DD 转换为 unix单位
            } else {
              data.expire_date = now + data.add_date * 31536000; // 当前时间加上有效期年份时间
            }
          } else {
            if (data.add_date === 0) {
              data.expire_date =
                new Date(Date.parse(data.date.replace(/-/g, '/'))).getTime() / 1000; // 将YYYY-MM-DD 转换为 unix单位
            } else {
              data.expire_date = params.expire_date + data.add_date * 31536000; // 有效期时间加上新增有效期年份时间
            }
          }
          this.$api.license.renewal(params.id, data).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.renewalSuccess'));
              this.getList(this.filter);
            }
          });
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delLicense(id) {
      this.$uxLoading.show();
      this.$api.license.delLicense(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 搜索
     */
    search() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变分组名称
     */
    change() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
<style lang="scss">
.ux-modal-box {
  overflow: inherit !important;
}
</style>
